import { render, staticRenderFns } from "./AccountPhones.vue?vue&type=template&id=074bab19&"
import script from "./AccountPhones.vue?vue&type=script&lang=js&"
export * from "./AccountPhones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports